import { Toaster as Sonner } from '@/components/ui/sonner';

export function Toaster() {
  return <Sonner />;
}